import { Switch as ChakraSwitch, type SwitchRootProps } from "@chakra-ui/react";

import { asSlotComponent } from "../internal/v3-slot";

const SwitchRoot = asSlotComponent(ChakraSwitch.Root);
const SwitchControl = asSlotComponent(ChakraSwitch.Control);
const SwitchThumb = asSlotComponent(ChakraSwitch.Thumb);
const SwitchHiddenInput = asSlotComponent(ChakraSwitch.HiddenInput);

export type SwitchProps = Omit<SwitchRootProps, "disabled"> & {
  disabled?: boolean;
  readOnly?: boolean;
  id?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function Switch({
  checked,
  disabled,
  readOnly,
  id,
  onChange,
  defaultChecked,
  ...props
}: SwitchProps) {
  return (
    <SwitchRoot
      colorPalette="blue"
      id={id}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      readOnly={readOnly}
      onCheckedChange={(details) => {
        onChange?.({
          target: { checked: details.checked }
        } as React.ChangeEvent<HTMLInputElement>);
      }}
      {...props}
    >
      <SwitchHiddenInput />
      <SwitchControl>
        <SwitchThumb />
      </SwitchControl>
    </SwitchRoot>
  );
}
